<template>
  <div class="warpper">
    <Head />
    <div class="flex content">
      <div class="con-nav">
        <div class="flex con-nav-top flex_zBetween">
          <div class="con-item" @click="handleBreedClick()">
            <img src="../assets/images/icon1.png" alt="" />
            <p>草畜产业</p>
          </div>
          <div class="con-item">
            <img src="../assets/images/icon2.png" alt="" />
            <p>枸杞产业</p>
          </div>
        </div>
        <div class="con-item con-nav-in">
          <img src="../assets/images/icon3.png" alt="" />
          <p>葡萄产业</p>
        </div>
        <div class="flex con-nav-ft flex_zBetween">
          <div class="con-item con-item1" @click="handlePlantClick()">
            <img src="../assets/images/icon4.png" alt="" />
            <p>黄花菜产业</p>
          </div>
          <div class="con-item con-item1">
            <img src="../assets/images/icon5.png" alt="" />
            <p>其他</p>
          </div>
        </div>
      </div>
      <div class="banner">
        <swiper class="swiper swiper-focus" :options="Banner" ref="FocusLun">
          <swiper-slide>
            <div class="banner_col whole-bgt">
              <img src="../assets/images/niu.jpeg" alt="" />
              <p>红寺堡区:引领移民群众走上麻庄大道</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="banner_col whole-bgt">
              <img src="../assets/images/gouqi.jpeg" alt="" />
              <p>红寺堡区:引领移民群众走上麻庄大道</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="banner_col whole-bgt">
              <img src="../assets/images/hhc.jpeg" alt="" />
              <p>红寺堡区:引领移民群众走上麻庄大道</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="banner_col whole-bgt">
              <img src="../assets/images/putao.jpeg" alt="" />
              <p>红寺堡区:引领移民群众走上麻庄大道</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="banner_col whole-bgt">
              <img src="../assets/images/xm.jpg" alt="" />
              <p>红寺堡区:引领移民群众走上麻庄大道</p>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination focus-pag"></div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from "@/components/Head.vue";
import Foot from "@/components/Foot.vue";
export default {
  name: "index",
  components: {
    Head,
    Foot,
  },
  data() {
    return {
      Banner: {
        pagination: {
          el: ".focus-pag",
          clickable: true,
        },
        loop: true,
        autoplay: true,
      },
    };
  },
  methods: {
    handleBreedClick() {
      this.$router.push({ name: "Screen" });
    },
    handlePlantClick() {
      window.open("http://plant.htzhny.com:7200/", "_blank");
    },
  },
  mounted() {},
};
</script>
<style scoped>
.warpper {
  background-image: url(../../src/assets/images/bj.jpg);
  min-height: 100vh;
}
.content {
  margin: 150px 0 0 140px;
}
.con-nav {
  width: 800px;
}

.con-nav-top {
  padding: 0 20px;
}
.con-nav-top .con-item:first-child {
  cursor: pointer;
}
.con-item {
  position: relative;
  width: 204px;
  height: 254px;
}

.con-item img {
  width: 100%;
  height: 100%;
}

.con-item p {
  position: absolute;
  top: 150px;
  left: 0;
  width: 100%;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.56);
  text-align: center;
}

.con-nav-in {
  width: 284px;
  height: 332px;
  margin: -130px auto;
}

.con-nav-in p {
  top: 220px;
  color: #ffffff;
  font-size: 22px;
}

.con-item1 {
  width: 256px;
  height: 298px;
}

.con-item1 p {
  top: 190px;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
}

.modal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.56);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
}

.modal:before {
  content: "";
  width: 100%;
  height: 742px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: url(../assets/images/login-bj.png);
  background-position: center;
  background-size: cover;
}

.modal_flex {
  width: 1000px;
  position: relative;
}

.modal-l {
  width: 628px;
  border: 1px solid #1aa2b0;
  background-color: rgba(0, 56, 215, 0.2);
  border-radius: 10px 0 0 10px;
  position: relative;
  height: 470px;
  z-index: 2;
  padding: 46px;
}

.modal-l::before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #01127b;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 10px 0 0 10px;
  z-index: -1;
  box-shadow: inset 0 0 46px 0 rgba(0, 255, 246, 0.2);
}

.modal-name {
  font-size: 47px;
  font-weight: bold;
  position: relative;
  z-index: 22;
}

.modal-name span {
  background-image: -webkit-linear-gradient(bottom, #b9e4ff, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.modal-img {
  position: absolute;
  bottom: 0;
  right: 0;
}

.modal-img img {
  width: 100%;
  height: 455px;
}

.modal-r {
  background-color: rgba(2, 45, 166, 0.76);
  border: 1px solid #1aa2b0;
  border-radius: 0 10px 10px 0;
  flex: 1;
  margin-left: -1px;
  padding: 0 40px;
}

.modal-lo {
  width: 284px;
  height: 34px;
  margin: 50px auto 30px;
}

.modal-lo img {
  width: 100%;
  height: 100%;
}

.form-group {
  border: 1px solid #1aa2b0;
  background-color: rgba(0, 155, 255, 0.4);
  border-radius: 5px;
  padding: 0 10px;
  margin-bottom: 30px;
}

.form-icon {
  width: 18px;
  height: 22px;
  margin-right: 8px;
}

.form-icon img {
  width: 100%;
  height: 100%;
}

.form-input {
  flex: 1;
}

.form-input input {
  width: 100%;
  border: 0;
  outline: none;
  background-color: transparent;
  font-size: 14px;
  height: 40px;
  color: #ffffff;
}

.form-input input::-webkit-input-placeholder {
  font-size: 14px;
  color: #ffffff;
}

.form-img {
  width: 90px;
  height: 38px;
  margin-left: 12px;
}

.form-img img {
  width: 100%;
  height: 100%;
}

.form_f .form-group {
  margin-bottom: 0;
}

.modal-r .btn {
  width: 100%;
  height: 40px;
  background: linear-gradient(to bottom, #007dee, #02dff7);
  color: #ffffff;
  border: 0;
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 6px;
  cursor: pointer;
  margin: 30px 0;
}

.form-ft a {
  font-size: 14px;
  color: #ffffff;
}

.banner {
  background-image: url(../assets/images/banner-k.png);
  width: 720px;
  height: 486px;
  padding: 4px 3px 5px 7px;
  border-radius: 14px;
  position: relative;
  margin: 50px 0 0 120px;
}
.swiper img,
.banner_col {
  width: 100%;
  height: 100%;
  position: relative;
}
.banner_col,
.swiper {
  border-radius: 14px;
  overflow: hidden;
}
.banner_col > img {
  object-fit: cover;
  height: 472px;
  min-height: 100%;
  min-width: 100%;
}
.banner_col p {
  background-color: rgba(0, 0, 0, 0.56);
  font-size: 20px;
  color: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 17px 20px;
}
.banner .swiper-pagination {
  bottom: 20px;
  right: 10px;
}
.banner /deep/ .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  opacity: 0.56;
  margin: 0 4px;
}
.banner /deep/ .swiper-pagination-bullet-active {
  background-color: #2bfaff;
  opacity: 1;
}
</style>
